export default "__VITE_ASSET__BXOVAzYq__"